import { Injectable } from '@angular/core';

import { Template } from "./template.model";
import { apiName } from "./data.service";
import { RestService } from "../../core/services/rest.service";

@Injectable()
export class TemplateApiService {

    constructor(
        private _restService: RestService
    ) { }

    onPost(object: Template, done: any) {
        this._restService.onPost(apiName, object, done);
    }

    onPut(object: Template, done: any) {
        this._restService.onPut(apiName, object, done);
    }

    onDelete(objectId: number, done: any) {
        this._restService.onDelete(apiName, objectId, done);
    }

    onGetByQuery(query: any, done: any) {
        query.order = "titulo";
        this._restService.onGetPost(apiName, query, done);
    }

    onGetById(objectId: number, done: any) {
        this._restService.onGetPostId(apiName, objectId, {}, done);
    }

    onGetApiUrl() {
        return apiName;
    }
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/rastreamentos/templates/template-api.service.ts
 **/